{
  "app": {
    "name": "POSS",
    "legend": "Pacific One Stop Shop"
  },
  "dashboard": {
    "statistics": "Estatísticas",
    "jurisdictions": "Jurisdições",
    "pendingDisbursements": "Desembolsos pendentes",
    "payments": "Pagamentos",
    "taxpayers": "Contribuintes",
    "firstPayment": "Primeiro pagamento",
    "lastPayment": "Último pagamento"
  },
  "config": {
    "tin": "PIN",
    "tinLegend": "POSS Identification Number"
  },
  "administration-user": {
    "title": {
      "page": "Usuarios",
      "page-taxpayer": "Contribuintes",
      "page-disable-tfa": "Desativar autenticação de fator duplo (2FA)",
      "activation-link-confirmation": "Confirmar link de ativação"
    },
    "label": {
      "userName": "Nome de usuário",
      "department": "Departamento",
      "roles": "Funções",
      "general-information": "Informações gerais",
      "user": "Novo usuário",
      "edit-user": "Editar usuário",
      "disabled": "Desativado",
      "email-confirmed": "E-mail confirmado",
      "invitation-sent-at": "Convite enviado em",
      "invitation-not-sent": "Não enviado",
      "locale": "Língua preferida",
      "disable": "Desabilitar",
      "enable": "Habilitar",
      "cancel": "Cancelar",
      "return": "Retornar"
    },
    "button": {
      "send-activation-link": "Enviar link de ativação",
      "resend-activation-link": "Reenviar link de ativação"
    },
    "validations": {
      "userName": "Nome de usuário é requerido"
    },
    "messages": {
      "disableTitle": "Desativar usuário",
      "confirmDisable": "Tem certeza que deseja desativar este usuário?",
      "confirmEnable": "Tem certeza de que deseja habilitar este usuário?",
      "savedSucessfully": "Salvo com sucesso",
      "enableTitle": "Habilitar usuário",
      "error": "Erro",
      "confirmDisableTfaTitle": "Desativar 2FA",
      "confirmDisableTfa": "Tem certeza de que deseja desativar a autenticação de fator duplo para o usuário \"{0}\"?",
      "tfaDisabledSucessfully": "Autenticação de fator duplo desativada com sucesso",
      "activation-link-sent": "Link de ativação enviado",
      "confirm-send-activation-link": "Tem certeza de que deseja enviar um link de ativação para este usuário?",
      "confirm-resend-activation-link": "Tem certeza de que deseja reenviar o link de ativação para este usuário?"
    }
  },
  "user-profile": {
    "title": {
      "page": "Perfil de usuário",
      "change-password": "Alterar a senha"
    },
    "label": {
      "userName": "Nome de usuário",
      "name": "Nome",
      "email": "e-mail",
      "locale": "língua preferida",
      "currentPassword": "Senha atual",
      "newPassword": "Nova senha",
      "repeatPassword": "Repetir a senha",
      "change-password": "Alterar a senha",
      "password": "Senha"
    },
    "message": {
      "password-changed": "Senha alterada com sucesso",
      "profile-updated": "Perfil atualizado com sucesso. Você deve fazer o login novamente para ver as mudanças",
      "password": "Atualize a senha da sua conta para mantê-la segura"
    }
  },
  "formDefinition": {
    "label": {
      "reconecting": "Reconectando",
      "reconected": "Reconectado"
    }
  },
  "inbox-notifications": {
    "title": {
      "inbox": "Caixa de correio"
    },
    "label": {
      "message": "Mensagem",
      "messages": "Mensagens",
      "read": "Lido",
      "inboxDate": "Data",
      "ok": "SIM",
      "no": "NÃO"
    }
  },
  "operations-economy-activity": {
    "title": {
      "page": "Atividade econômica"
    },
    "label": {
      "code": "Código",
      "name": "Nome",
      "description": "Descrição",
      "newButton": "Novo",
      "saveButton": "Manter"
    },
    "header": {
      "code": "Código",
      "name": "Nome",
      "description": "Descrição",
      "actions": "Ações"
    },
    "button": {
      "cancel": "Cancelar",
      "delete": "Remover",
      "save": "Manter",
      "search": "Olhe para",
      "new": "Novo",
      "clean": "Limpar",
      "ok": "Aceitar"
    },
    "validations": {
      "codeRequired": "O código é obrigatório",
      "nameRequired": "O nome é obrigatório",
      "descriptionRequired": "Descrição é obrigatória"
    },
    "messages": {
      "confirmTitle": "Remover",
      "confirmDeleted": "Tem certeza de que deseja excluir esta informação?",
      "deletedSucessfully": "Foi removido com sucesso",
      "savedSucessfully": "Informação armazenada",
      "error": "Erro"
    }
  },
  "common": {
    "label": {
      "valueType": "Tipo de valor",
      "theme": "Tema",
      "feedback": "Comentários",
      "logout": "Sair",
      "print": "Imprimir",
      "phoneNumberArea": "Área",
      "newRecord": "Novo",
      "editRecord": "Atualizar",
      "current-user": "Usuário atual",
      "user-profile": "Perfil de usuário",
      "name": "Nome",
      "givenNames": "Nomes",
      "surnames": "Apelidos",
      "search": "Olhe para",
      "clean": "Limpar",
      "create": "Novo",
      "ok": "Aceitar",
      "next": "Próximo",
      "cancel": "Cancelar",
      "back": "Atrás",
      "edit": "Editar",
      "actions": "Ações",
      "selectAction": "Selecionar ação",
      "send": "Mandar",
      "close": "Desligar",
      "add": "Adicionar",
      "email": "e-mail",
      "phoneNumber": "Telefone",
      "id": "ID ",
      "password": "Senha",
      "state": "Desativado",
      "translation": "Tradução",
      "language": "Idioma",
      "value": "Valor",
      "translatable": "Traduzível",
      "politicalDivision": "Divisão política",
      "department": "Departamento / Província / Estado",
      "city": "Cidade",
      "zipCode": "Código postal",
      "cellPhone": "Móvel",
      "personType": "Tipo de pessoa",
      "businessName": "Nome ou nome da empresa",
      "taxpayerName": "Nome ou nome da empresa",
      "tradeName": "Nome comercial",
      "address": "Endereço",
      "country": "País",
      "localization": "Localização",
      "website": "Site web",
      "fileSearch": "Pesquisar arquivo",
      "fileRequirements": "PDF · Máx. 9,6 MB",
      "fileUploading": "Carregando...",
      "fileUploaded": "Carregado",
      "fileUploadError": "Não foi possível carregar o arquivo",
      "fileSelect": "Selecionar",
      "fileReplace": "Substituir",
      "fileRemove": "Remover",
      "fileRemoving": "Removendo...",
      "fileRemoveError": "Não foi possível remover o arquivo",
      "fileUpload": "Subir arquivo",
      "fileDownload": "? Fazer download do arquivo",
      "noFileSelected": "Nenhum arquivo selecionado",
      "dateFrom": "Data de",
      "dateTo": "Data Até",
      "noFound": "Não há resultado",
      "taxReturnCurrency": "Declaração de moeda",
      "page-showing": "Mostrando",
      "page-to": "para",
      "page-of": "a partir de",
      "page-entries": "registros",
      "loading": "Carregando ...",
      "error": "Erro",
      "unableToLoad": "Não foi possível carregar os dados. Tente novamente.",
      "retry": "Tentar novamente",
      "currency": "moeda",
      "paymentMethod": "Forma de pagamento",
      "attachment": "Anexar",
      "paymentReference": "Informação complementar",
      "supportDocument": "Documento de soporte",
      "payment": "Pagamento",
      "backToHome": "Voltar ao início",
      "createdBy": "Criado por",
      "bank": "Banco",
      "bankInformation": "Informações bancárias",
      "excel": "Excel",
      "days": {
        "monday": "seg",
        "tuesday": "Te",
        "wednesday": "Qu",
        "thursday": "Qu",
        "friday": "Sex",
        "saturday": "Sentado",
        "sunday": "Do"
      },
      "months": {
        "january": "Janeiro",
        "february": "fevereiro",
        "march": "Março",
        "april": "abril",
        "may": "Maio",
        "june": "Junho",
        "july": "julho",
        "august": "agosto",
        "september": "setembro",
        "october": "Outubro",
        "november": "novembro",
        "december": "dezembro"
      },
      "type": "Modelo",
      "numeric": "numérico",
      "date": "data",
      "list": "Lista",
      "text": "Texto",
      "header": "cabeçalho",
      "description": "Descrição",
      "ommited": "Omitido",
      "all": "Tudo",
      "see": "Vejo",
      "filters": "Filtros"
    },
    "descriptions": {
      "taxReturnCurrency": "Moeda a ser usada para declarações",
      "can-access": "Permite acesso a",
      "contactTaxIdNumber-tax": "Número de identificação fiscal do contacto no país de residência"
    },
    "button": {
      "add": "Adicionar",
      "edit": "Editar",
      "find": "Olhe para",
      "cancel": "Cancelar",
      "delete": "Remover",
      "save": "Manter",
      "clean": "Limpar",
      "new": "Novo",
      "show": "Ver",
      "download": "Download",
      "file": "Anexar",
      "previous": "Anterior",
      "next": "Próximo",
      "send": "Mandar",
      "translate": "Traduções",
      "return": "Retornar",
      "continue": "Prosseguir",
      "newVersion": "Nova versão"
    },
    "dialog": {
      "dialog-error": "Erros",
      "table-title-header": "Mensagens",
      "warning-title": "Atenção"
    },
    "messages": {
      "error-500": "Ocorreu um erro no servidor, entre em contato com o administrador.",
      "fileUpload": "O arquivo foi carregado com sucesso",
      "savedSucessfully": "Armazenado com sucesso",
      "deletedSucessfully": "Removido com sucesso",
      "pleaseWait": "Por favor espere",
      "nofileContent": "O arquivo não tem conteúdo",
      "errorMessageSystem": "O parâmetro '$ {code}' não foi encontrado no catálogo",
      "warningInactiveSession": "Atenção: Nenhuma atividade foi detectada há algum tempo. A sessão será encerrada em 1 minuto se nenhuma atividade for detectada ainda",
      "sessionIdleCountdown": "Sua sessão será encerrada em {{count}} segundos.",
      "closingSession": "Fechando a sessão ...",
      "confirm": "Tem certeza de que deseja realizar esta ação?",
      "uploadProcessing": "A informação foi carregada e está sendo processada, você será notificado assim que terminar o processamento.",
      "messageSent": "Mensagem enviada com sucesso"
    },
    "validations": {
      "nameRequired": "O campo nome é obrigatório",
      "fieldRequired": "O campo é obrigatório",
      "numbersAndLetters": "Apenas números e letras",
      "email": "E-mail inválido",
      "minStringValue": "O campo deve ter pelo menos {{min}} caracteres",
      "maxStringValue": "O campo deve ter no máximo {{max}} caracteres",
      "minNumberValue": "O valor do campo deve ser no mínimo {{min}}",
      "maxNumberValue": "O valor do campo deve ser no máximo {{max}}"
    },
    "languages": {
      "spanish": "Espanhol (Espanha)",
      "english": "Inglês dos Estados Unidos"
    },
    "taxpayer-request-types": {
      "enroll": "Registro",
      "update": "Melhoria"
    },
    "taxpayer-request-states": {
      "pending": "Brinco",
      "pending_additional_information": "Pendente para informações adicionais",
      "approved": "Aprovado",
      "rejected": "Rejeitado"
    },
    "taxreturn-types": {
      "original": "Original",
      "amending": "Retificadora",
      "unsubscribe": "Cancelar subscrição"
    },
    "taxreturn-status": {
      "pending": "Brinco",
      "accepted": "Aceitaram",
      "approved": "Aprovado",
      "rejected": "Rejeitado",
      "reconciled": "Reconciliado"
    },
    "yes-no": {
      "yes": "sim",
      "no": "NÃO"
    }
  },
  "collections": {
    "label": {
      "maximumNumberOfTaxpayers": "Maximum number of taxpayers",
      "durationProcess": "Dias de duração",
      "descriptionProcess": "Descrição",
      "selectedTaxpayers": "Selecionado",
      "excludedTaxpayers": "Excluído",
      "debtDetail": "Veja detalhes da dívida",
      "lastTaxreturn": "última declaração",
      "lastPayment": "Ultimo pagamento",
      "excluded": "Excluído",
      "debtOriginal": "Dívida original",
      "debtFinal": "Dívida final",
      "currentDebt": "Dívida atual",
      "code": "Identificador",
      "taxpayer": "Contribuinte",
      "start": "Começar",
      "end": "O fim",
      "newCommunication": "Nova comunicação",
      "typeCommunication": "Canal de comunicação",
      "saveCommunication": "Salvar comunicação",
      "communicationChannelPhone": "Telefone",
      "communicationChannelMail": "E-Mail",
      "process": "Processo",
      "startProcess": "Processo iniciado",
      "recoveredDebt": "Dívida recuperada",
      "endProcess": "Fim do processo",
      "timeElapsed": "Resposta média",
      "countProcess": "Processos",
      "countEndedProcess": "Finalizado",
      "countInProgressProcess": "Em processo",
      "countTaxpayerProcess": "contribuintes",
      "unpaid": "Não pago",
      "noCommunications": "Sem comunicações"
    },
    "title": {
      "detailCollection": "Informação de pagamento",
      "newProcessCollection": "Novo processo de cobrança",
      "selectionTaxpayerProcess": "Seleção de contribuintes",
      "indicators": "Indicadores",
      "taxreturnAndPayments": "Declarações de impostos e pagamentos",
      "communications": "Comunicações",
      "processCollection": "Processos de cobrança",
      "StatisticQuery": "Período de consulta",
      "StatisticQueryResult": "Resultados"
    },
    "status": {
      "started": "Iniciado",
      "ended": "Finalizado"
    },
    "messages": {
      "newProcessCreated": "Foi criado um novo processo de cobrança com [limite] contribuintes que começou em [startDate] e termina em [endDate]"
    }
  },
  "parameters-catalog": {
    "title": {
      "catalogType": "Tipo de catálogo",
      "catalog": "Catálogo"
    },
    "label": {
      "type": "Tipo",
      "name": "Nome",
      "description": "Descrição",
      "field": "Campo",
      "label": "Etiqueta ",
      "parent": "Pai",
      "newCatalogType": "novo tipo de catálogo",
      "newCatalog": "Novo catálogo",
      "code": "Código",
      "addDefinition": "Adicionar definição",
      "newDefinition": "Nova definição",
      "extaFilds": "Campos de usuário adicionais",
      "addNameTraslation": "Adicionar tradução"
    },
    "validations": {
      "exists": "O registro já existe",
      "letterNumberhyphen": "Somente letras, números e hifens são permitidos"
    },
    "messages": {
      "languageExist": "O idioma já foi adicionado"
    }
  },
  "parameters-enviroments": {
    "title": {
      "page-security": "Variáveis ??de ambiente (segurança)",
      "page-application": "Variáveis ??de ambiente (aplicativo)"
    },
    "label": {
      "name": "Nome",
      "type": "Tipo",
      "value": "Valor",
      "newButton": "Novo",
      "saveButton": "Manter"
    },
    "validations": {
      "nameRequired": "O campo nome é obrigatório",
      "typeRequired": "O campo Tipo é obrigatório",
      "textValueRequired": "O campo Valor é obrigatório"
    },
    "messages": {
      "savedSucessfully": "Salvo satisfatoriamente",
      "error": "Erro"
    }
  },
  "home-template": {
    "title": {
      "page-home": "Modelo de página de destino",
      "page-terms": "Termos e condições do modelo"
    },
    "label": {
      "template": "Modelo"
    },
    "messages": {
      "savedSucessfully": "Salvo com sucesso"
    }
  },
  "parameters-notification-template": {
    "title": {
      "page-application": "App de notificações",
      "page-security": "Notificações de Segurança"
    },
    "label": {
      "template": "Modelo",
      "emailNotification": "Notificar por e-mail",
      "pushNotification": "Notificar caixa de correio",
      "newTemplate": "Novo modelo",
      "id": "Modelo id",
      "subject": "Subject",
      "inbox": "Bandeja"
    },
    "validations": {
      "templateRequired": "O modelo é obrigatório"
    }
  },
  "taxpayer-fields": {
    "title": {
      "page": "Campos de contribuinte",
      "enabled": "Habilitado"
    },
    "header": {
      "fieldCode": "Código",
      "fieldName": "Nome",
      "fieldSection": "Seção",
      "actions": "Habilitado"
    },
    "messages": {
      "savedSucessfully": "Informação armazenada com sucesso"
    }
  },
  "penalties": {
    "label": {
      "periodFrom": "Periodo de",
      "periodTo": "Período para"
    },
    "title": {
      "listPenalties": "Configuração de penalidades"
    }
  },
  "management-report": {
    "label": {
      "taxpayerByCountry": "Para o país",
      "taxpayerByOperation": "Por operação",
      "taxpayerAmount": "Quantidade",
      "taxAmount": "Por imposto",
      "dateFrom": "Datas de",
      "dateTo": "Data Até"
    },
    "title": {
      "pageTaxpayer": "Contribuintes",
      "pageTaxreturn": "Declarações",
      "pagePayment": "Pagamentos"
    },
    "validations": {
      "dateRequired": "Esta data é obrigatória",
      "dateToGreaterThan": "A data deve ser maior que a data de início",
      "dateLessThreeMonths": "A data deve ser inferior a 12 meses a partir da data de início"
    }
  },
  "security-apikey": {
    "title": {
      "page": "Api Keys"
    },
    "label": {
      "name": "Nobre",
      "new-api-key": "Nova Chave",
      "expiration": "Data de expiração",
      "your-pat": "Seu novo token de acesso pessoal",
      "revoke-token": "Revogar Token"
    },
    "validations": {
      "name": "O nome da chave de API é obrigatório",
      "expiration": "A data de expiração é obrigatória"
    },
    "message": {
      "key-created": "Certifique-se de salvá-lo - você não poderá acessá-lo novamente.",
      "confirm-revoke": "Tem certeza de que deseja revogar o token?"
    }
  },
  "audit-log": {
    "title": {
      "event-title": "Logs de eventos",
      "http-title": "LOGS Http",
      "application": "Aplicativo",
      "security": "Segurança"
    },
    "label": {
      "dateFrom": "Data de",
      "dateTo": "Data Até",
      "user": "Do utilizador",
      "aggregateName": "Consulta de Nome",
      "eventName": "Nome do evento",
      "httpMethod": "Método Http",
      "httpStatusCode": "Código de status Http"
    },
    "header": {},
    "validations": {
      "dateRequired": "Esta data é obrigatória",
      "dateToGreaterThan": "A data deve ser maior que a data de início",
      "dateLessThreeMonths": "A data deve ser inferior a 3 meses a partir da data de início"
    },
    "messages": {}
  },
  "disable-tfa": {
    "label": {
      "title": "Desative a autenticação de dois fatores (2FA)",
      "disable": "Desativar 2FA"
    },
    "validations": {},
    "message": {
      "alert-1": "Esta ação desativa apenas 2FA.",
      "alert-2": "Desativar 2FA não altera as chaves usadas em aplicativos autenticadores.",
      "alert-3": "Se você deseja alterar a chave usada em um aplicativo autenticador, você deve:",
      "alert-4": "redefina as chaves do autenticador.",
      "success": "2fa foi desativado. Você pode reativar 2fa ao configurar um aplicativo autenticador"
    }
  },
  "enable-authenticator": {
    "label": {
      "title": "Configurar aplicativo autenticador",
      "verification-code": "Código de verificação",
      "verification-code-digit": "Dígito {{position}} de {{total}}",
      "verify": "Verificar",
      "manual-key": "Chave de configuração manual",
      "copy-key": "Copiar chave",
      "key-copied": "Chave copiada para a área de transferência.",
      "key-copied-button": "Copiado",
      "copy-unavailable": "Não foi possível copiar a chave. Copie-a manualmente.",
      "security-recommendations": "Recomendações de segurança",
      "security-recommendations-detail": "Guarde os códigos de recuperação em um local seguro e não compartilhe a chave de configuração."
    },
    "validations": {
      "code": "Código de verificação é obrigatório"
    },
    "message": {
      "instruction-1": "Baixe um aplicativo autenticador como o Microsoft Authenticator para",
      "and": "S ",
      "or": "ou",
      "for": "para ",
      "instruction-2": "Leia o código QR ou insira esta chave",
      "instruction-3": "dentro de seu aplicativo autenticador. Espaços e separadores não importam.",
      "instruction-4": " Depois de escanear o código QR ou inserir a chave acima, seu aplicativo de autenticação fornecerá um código exclusivo. Digite o código no campo de confirmação abaixo."
    }
  },
  "recovery-codes": {
    "label": {
      "title": "Códigos de Recuperação",
      "available-once": "Guarde-os agora: eles não serão exibidos integralmente novamente."
    },
    "message": {
      "save-security-codes": "Guarde esses códigos em um lugar seguro.",
      "if-you-lose": "Se você perder seu dispositivo e não tiver os códigos de recuperação, perderá o acesso à sua conta."
    }
  },
  "generate-recovery-codes": {
    "label": {
      "title": "Gerar códigos de recuperação para autenticação de dois fatores (2FA)",
      "generate": "Gerar Códigos de Recuperação"
    },
    "validations": {},
    "message": {
      "alert-1": "Coloque esses códigos em um lugar seguro.",
      "alert-2": " Se você perder seu dispositivo e não tiver os códigos de recuperação, perderá o acesso à sua conta.",
      "alert-3": "A geração de novos códigos de recuperação não altera as chaves usadas no aplicativo autenticador. Se você deseja alterar a chave usada no aplicativo autenticador, você deve",
      "alert-4": " redefina suas chaves de autenticação."
    }
  },
  "security-login": {
    "title": {
      "login": "Login "
    },
    "label": {
      "username": "Usuario",
      "password": "Senha",
      "rememberMe": "Lembre de mim",
      "loginButton": "Iniciar sessão",
      "passwordRecovery": "Recuperar senha",
      "notRegistered": "não registrado ainda?",
      "signup": "cadastre-se",
      "loginAlternative": "ou",
      "forgotPassword": " Você esqueceu sua senha ?",
      "next": "Próximo",
      "forgotPasswordInstructions": "Digite seu nome de usuário e enviaremos um e-mail com as instruções para recuperar",
      "externalLogin": "Login Externo",
      "captcha-placeholder": "Digite o captcha"
    },
    "validations": {
      "usernameRequired": "O campo do usuário é obrigatório",
      "passwordRequired": "Senha requerida",
      "captchaValidationRequired": "A validação de captcha é necessária"
    }
  },
  "login-with-2fa": {
    "title": {
      "login": "Autenticação de dois fatores",
      "login-recovery": "Recuperar código de verificação"
    },
    "label": {
      "twoFactorCode": "Código autenticador",
      "recoveryCode": "Código de recuperação",
      "rememberBrowser": "Lembre-se deste navegador",
      "verificationCodeInstructions": "Digite o código de seis dígitos do seu aplicativo autenticador para continuar.",
      "loginButton": "Iniciar sessão",
      "loginRecovery": "Login com código de recuperação"
    },
    "message": {
      "no-access": "Você não tem acesso ao seu dispositivo de autenticação? você pode",
      "trustedBrowser": "Ignore a verificação neste navegador confiável.",
      "recovery-requested": " Você solicitou o login com um código de recuperação. Este login não será lembrado até que você forneça um código de aplicativo de autenticação ao fazer login ou desative o 2FA e faça login novamente."
    },
    "validations": {
      "twoFactorCode": "O campo do código de autenticação é obrigatório",
      "recoveryCode": "O campo do código de recuperação é obrigatório"
    }
  },
  "security-password-recovery": {
    "label": {
      "title": "Recuperar senha",
      "changePassword": "Alterar a senha",
      "userName": "Usuario",
      "newPassword": "Nova senha",
      "repeatPassword": "repetir a senha",
      "returnLogin": "Voltar para o login"
    },
    "message": {
      "email-sended": "Email de recuperação de senha enviado",
      "password-changed": "A senha foi alterada com sucesso"
    },
    "validations": {
      "newPassword": "A nova senha deve ter pelo menos 6 caracteres",
      "passwordEqual": "As senhas não coincidem"
    }
  },
  "reset-authenticator": {
    "label": {
      "title": "Instale o aplicativo autenticador",
      "reset": "Redefinir a chave do autenticador",
      "configure": "Configurar aplicativo autenticador"
    },
    "validations": {},
    "message": {
      "alert-1": "Se você redefinir a chave do autenticador, o aplicativo do autenticador não funcionará até que você o reconfigure.",
      "alert-2": "Este processo desativa 2FA até que você verifique seu aplicativo autenticador.",
      "alert-3": "Se você não concluir a configuração do aplicativo autenticador, poderá perder o acesso à sua conta.",
      "success": "Sua chave do autenticador foi redefinida e você precisará configurar o aplicativo do autenticador usando a nova chave."
    }
  },
  "tfa": {
    "title": {
      "page": "Autenticação de fator duplo"
    },
    "label": {
      "title": "Autenticação de dois fatores (2FA)",
      "authenticator-app": "Aplicativo Authenticator",
      "setup-authenticator": "Configurar aplicativo autenticador",
      "add-authenticator": "Adicionar aplicativo autenticador",
      "reset-authenticator": "Reinicie o aplicativo autenticador",
      "reset-recovery-codes": "Redefinir códigos de recuperação",
      "disable-2fa": "Desativar 2FA",
      "forget-this-browser": "Esqueça este navegador",
      "status-enabled": "Ativado",
      "status-disabled": "Não configurado",
      "recovery-codes-remaining": "códigos de recuperação disponíveis",
      "danger-zone": "Ações de alto impacto"
    },
    "validations": {},
    "message": {
      "two-factor-forgotten": "Este navegador foi esquecido. Quando você fizer login novamente neste navegador, será solicitado o seu código 2fa.",
      "no-codes-left-1": "Você não tem códigos de recuperação disponíveis.",
      "no-codes-left-2": "Deve",
      "no-codes-left-3": "gerar um novo conjunto de códigos de recuperação",
      "no-codes-left-4": "antes de fazer o login com um código de recuperação.",
      "some-codes-left-1": "Tem",
      "some-codes-left-2": "código (s) de recuperação disponíveis.",
      "some-codes-left-3": "Deve",
      "some-codes-left-4": "gerar um novo conjunto de códigos de recuperação"
    }
  },
  "roles": {
    "account_reports": "Consulta de conta",
    "catalogs_admin": "Gerente de Catálogo",
    "details_reports": "Detalhe de relatórios",
    "environments_admin": "Gerente de Variáveis ??de Ambiente",
    "forms_admin": "Form Manager",
    "management_report_admin": "Gerente de Relatório",
    "notifications_admin": "Gerente de Notificações",
    "system_auditor": "Auditor de Sistema",
    "taxpayer_reports": "Consultas de contribuintes",
    "taxpayers_admin": "Administrador de contribuintes",
    "payments_admin": "Gerente de Pagamentos",
    "taxpayers_approver": "Aprovador de contribuintes",
    "taxreturn_approver": "Aprovador de declarações",
    "taxreturn_reports": "Consultas de declarações",
    "tfa_admin": "Administrador 2FA",
    "users_admin": "Gerente de Usuário",
    "current_account_admin": "Gerente de conta atual",
    "debt_collection_analyst": "Analista de cobrança",
    "debt_collection_manager": "Gerente de cobrança",
    "debt_collection_officer": "Oficial de cobrança",
    "taxpayer_communication": "Comunicação do contribuinte",
    "non_compliance_analyst": "Analista de non compliance",
    "collection_statistics": "Análise de coleção",
    "compliance_statistics": "Análise de não conformidade"
  },
  "taxreturn-evaluation": {
    "title": {
      "page": "Revisão de retificações",
      "approve": "Aprovar retificação",
      "reject": "Rejeitar retificação",
      "dialog-confirm": "confirme"
    },
    "label": {
      "nit": "CPF/CNPJ",
      "taxreturnNumber": "Número da Declaração",
      "country": "País",
      "taxId": "Imposto",
      "taxreturnType": "Tipo de Declaração",
      "name": "Número de contribuinte",
      "form": "Forma",
      "approve": "Passar",
      "taxpayer": "Contribuinte",
      "comments": "Comentários",
      "general-comments": "Data de",
      "periodFrom": "Data Até",
      "periodTo": "Comentários gerais"
    },
    "header": {
      "actions": "Ações",
      "nit": "CPF/CNPJ",
      "name": "Nome do contribuinte",
      "taxReturnNumber": "Número de contribuinte",
      "form": "Forma",
      "tax": "Imposto",
      "taxreturnStatus": "Estado",
      "period": "Período",
      "createDate": "Data"
    },
    "validations": {},
    "messages": {
      "approved": "Declaração Aprovada",
      "rejected": "Declaração Rejeitada",
      "confirm": "Tem certeza de que deseja realizar esta ação?"
    },
    "button": {
      "reject": "Rejeitar",
      "approve": "Passar"
    }
  },
  "taxes": {
    "title": {
      "page": "Gerenciar impostos"
    },
    "label": {
      "name": "Nome",
      "rateType": "Tipo de taxa",
      "shortName": "Nome curto",
      "code": "Código",
      "newButton": "Novo",
      "saveButton": "Manter",
      "tabEditTax": "em geral",
      "tabRates": "Honorários",
      "rate": "Taxa",
      "tabPeriodicity": "Periodicidade",
      "tabOperations": "Operações",
      "dateFrom": "Datas de",
      "dateTo": "Data Até",
      "value": "Valor",
      "periodicityType": "Tipo de periodicidade",
      "filingDueDay": "Dia de expiração",
      "paymentDueDay": "Dia de pagamento"
    },
    "header": {
      "code": "Código",
      "name": "Nome",
      "rateType": "Tipo de taxa",
      "value": "Valor",
      "dateFrom": "Datas de",
      "dateTo": "Data Até",
      "shortName": "Nome curto",
      "actions": "Ações",
      "periodicityType": "Tipo de periodicidade",
      "filingDueDay": "Dia de expiração"
    },
    "validations": {
      "rateTypeRequired": "O campo do tipo de taxa é obrigatório",
      "shortNameRequired": "O campo do nome curto é obrigatório",
      "codeRequired": "O campo do código é obrigatório",
      "valueLessThan100": "O campo de valor deve ser menor que 100%",
      "valueRequired": "O campo de valor é obrigatório",
      "dateFromRequired": "O campo data de é obrigatório",
      "dateToRequired": "O campo data é obrigatório",
      "filingDueDayRequired": "O campo do dia de vencimento é obrigatório",
      "periodicityTypeRequired": "O campo do tipo de periodicidade é obrigatório"
    },
    "messages": {
      "savedSuccessfully": "Foi salvo com sucesso",
      "deletedSuccessfully": "Foi removido com sucesso",
      "error": "Erro"
    }
  },
  "reportOperation": {
    "title": {
      "page": "Gerenciar relatórios de operações",
      "warning": "Aviso"
    },
    "label": {
      "operation": "Operação",
      "report": "Relatório"
    },
    "header": {
      "operation": "Operação",
      "report": "Relatório",
      "actions": "Ações"
    },
    "messages": {
      "removeReportOperation": "Você tem certeza que quer apagar isso?"
    }
  },
  "reports": {
    "title": {
      "page": "Gerenciar relatórios",
      "report": "Relatório",
      "versions": "Versões"
    },
    "label": {
      "name": "Nome",
      "shortName": "Nome curto",
      "code": "Código",
      "newButton": "Novo",
      "saveButton": "Manter",
      "tabEditReport": "em geral",
      "tabPeriodicity": "Periodicidade",
      "dateFrom": "Datas de",
      "dateTo": "Data Até",
      "periodicityType": "Tipo de periodicidade",
      "filingDueDay": "Dia de expiração"
    },
    "header": {
      "code": "Código",
      "name": "Nome",
      "shortName": "Nome curto",
      "actions": "Ações",
      "dateFrom": "Datas de",
      "dateTo": "Data Até",
      "periodicityType": "Tipo de periodicidade",
      "filingDueDay": "Dia de expiração"
    },
    "validations": {
      "shortNameRequired": "O campo do nome curto é obrigatório",
      "codeRequired": "O campo do código é obrigatório",
      "dateFromRequired": "O campo data de é obrigatório",
      "dateToRequired": "O campo data é obrigatório",
      "filingDueDayRequired": "O campo do dia de vencimento é obrigatório",
      "periodicityTypeRequired": "O campo do tipo de periodicidade é obrigatório"
    },
    "messages": {
      "savedSuccessfully": "Foi salvo com sucesso",
      "deletedSuccessfully": "Foi removido com sucesso",
      "error": "Erro"
    }
  },
  "report-cells": {
    "title": {
      "page": "Caixas"
    },
    "label": {
      "code": "Código da caixa",
      "name": "Caixa de Nome",
      "description": "Descrição",
      "formula": "Fórmula",
      "order": "Pedido",
      "type": "Tipo",
      "numeric": "Numérico",
      "currency": "Moeda",
      "date": "Data",
      "list": "Pronto",
      "text": "Texto",
      "catalogType": "Tipo de Catálogo",
      "mandatory": "Obrigatório"
    },
    "messages": {
      "confirmTitle": "Remover",
      "confirmDeleted": "Tem certeza que deseja deletar?"
    }
  },
  "report-version": {
    "title": {
      "page": "Relatório de versão"
    },
    "label": {
      "version": "Versão",
      "formVersion": "Relatório de versão",
      "startDate": "Data de",
      "endDate": "Data para",
      "formCode": "Código",
      "formName": "Nome",
      "since": "Desde a",
      "tabVersion": "Versão",
      "fields": "Caixas"
    },
    "messages": {
      "confirmTitle": "Remover",
      "confirmDeleted": "Você tem certeza que quer apagar isso?"
    }
  },
  "taxOperation": {
    "title": {
      "page": "Gerenciar operações fiscais",
      "warning": "Aviso"
    },
    "label": {
      "operation": "Operação",
      "tax": "Imposto"
    },
    "header": {
      "operation": "Operação",
      "tax": "Imposto",
      "actions": "Ações"
    },
    "messages": {
      "removeTaxOperation": "Você tem certeza que quer apagar isso?",
      "allOperationsLinked": "Todas as operações já estão vinculadas a este imposto",
      "noLinkedOperations": "Não há operações vinculadas a este imposto"
    }
  },
  "report-details": {
    "stateType": {
      "processing": "Em processamento",
      "error": "Erro",
      "accepted": "Aceitaram",
      "processed": "Processado"
    },
    "title": {
      "page": "Consulta de relatórios"
    },
    "label": {
      "reportNumber": "Número do relatório",
      "reportType": "Tipo de relatório",
      "operations": "tipo de operação",
      "taxpayerNumber": "CPF/CNPJ",
      "taxpayerName": "Nome do contribuinte",
      "registrationDate": "Data de registro",
      "period": "período",
      "reportName": "Nome do relatório",
      "record": "Valores",
      "index": "Fileira",
      "type": "Tipo",
      "active": "Ativo",
      "taxReportState": "Estado"
    }
  },
  "payment-file-status": {
    "processing": "Processando",
    "error": "Erro",
    "pending": "Pendente",
    "accepted": "Aceito",
    "rejected": "Rejeitado",
    "processed": "Processado",
    "received": "Recebido"
  },
  "taxreturn-report": {
    "title": {
      "page": "Veja as declarações"
    },
    "label": {
      "nit": "CPF/CNPJ",
      "taxreturnNumber": "Número da Declaração",
      "country": "País",
      "formId": "Nome do formulario",
      "taxreturnType": "Tipo de Declaração",
      "taxreturnStatus": "Estado",
      "name": "Nome do contribuinte",
      "period": "Período",
      "periodFrom": "Data de",
      "periodTo": "Data Até",
      "active": "Ativo",
      "overview": "em geral",
      "taxreturn": "Declaração",
      "createDate": "Data",
      "approve": "Aprovado",
      "comments": "Comentários"
    },
    "header": {
      "actions": "Ações",
      "nit": "CPF/CNPJ",
      "name": "Nome do contribuinte",
      "taxReturnNumber": "Número da Declaração",
      "createDate": "Data",
      "taxreturnType": "Tipo de Declaração",
      "taxreturnStatus": "Estado",
      "form": "Forma",
      "period": "Período",
      "active": "Ativo",
      "rejectionReason": "Razão para rejeição"
    },
    "validations": {},
    "messages": {
      "periodMessage": "Para períodos anuais formato AAAA, período mensal / trimestral AAAAMM"
    },
    "button": {}
  },
  "non-compliances": {
    "label": {
      "period": "Período",
      "expirationDate": "Data de validade",
      "NotificationDate": "Data de notificação",
      "presentationDate": "Data de apresentação",
      "wait": "Espere",
      "penalty": "Pena",
      "declarationAmount": "Valor da declaração",
      "paymentAmount": "Montante do pagamento",
      "days": "dias",
      "countTaxpayerNotified": "Notificações",
      "countTaxpayerCompliance": "Elogios",
      "compliancePercentage": "Observância",
      "elapsedTime": "Tempo médio",
      "debtGenerated": "Dívida gerada"
    },
    "title": {
      "nonCompliancesTax": "Incumprimento devido ao imposto",
      "nonCompliances": "Não conformidades",
      "nonCompliancesPayments": "Pagamentos pendentes",
      "StatisticQuery": "Período de consulta",
      "StatisticQueryResult": "Resultados"
    }
  },
  "taxpayer-current-account": {
    "title": {
      "currentAccount": "Conta corrente",
      "amendingCredit": "Consulta de saldo",
      "currentAccountTransaction": "Detalhe de transações",
      "transactionAdjustment": "Ajuste de equilíbrio"
    },
    "label": {
      "nit": "CPF/CNPJ",
      "tax": "Imposto",
      "taxCode": "Código de Imposto",
      "period": "Período",
      "taxAmount": "Valor do imposto",
      "penalty": "Multa",
      "interest": "Taxas",
      "taxArrears": "Mora",
      "total": "Total",
      "expirationDate": "Data de validade",
      "accountType": "Tipo de conta",
      "balance": "Equilíbrio",
      "date": "Data",
      "transactionType": "Tipo de transação",
      "value": "Valor",
      "document": "Documento",
      "taxpayerName": "Nome",
      "credit": "Crédito",
      "debit": "Débito"
    },
    "dialog": {},
    "messages": {},
    "validations": {
      "nit-required": "Id é obrigatório"
    }
  },
  "taxpayer-payments": {
    "title": {
      "page": "Inquérito de pagamento",
      "paymentsByJurisdiction": "Pagamentos por jurisdição",
      "pagePayments": "Registro de pagamento",
      "selectTaxReturn": "Selecione Declaração de Imposto",
      "pageUploadPayments": "Carga de pagamentos",
      "reconciliationPayments": "Reconciliação de pagamentos.",
      "paymentsTaxpayer": "Pagamentos informados pelo contribuinte",
      "paymentsTaxCollect": "Pagamentos informados pela entidade cobradora.",
      "concialiation": "Conciliação",
      "checkBankInformation": "Verifique as informações bancárias"
    },
    "label": {
      "registerPayment": "Registro de pagamento",
      "amountTaxReturn": "Valor da declaração",
      "amountTaxpayer": "Montante do contribuinte",
      "totalDebt": "Dívida total",
      "amountBank": "Montante do banco",
      "amountFrom": "Montante de",
      "amountTo": "Montante até",
      "tax-id": "CPF/CNPJ",
      "name": "Nome",
      "date-from": "Data de",
      "date-to": "Data Até",
      "date-payment": "Dia do pagamento",
      "payment-number": "Número de pagamento",
      "exchange-rate": "Taxa de câmbio",
      "local-amount": "Valor em moeda local",
      "tax": "Imposto",
      "amount": "Resultar",
      "excelDefinition": "Definição de arquivo Excel",
      "taxCollector": "Coletor de impostos",
      "swiftNumber": "Número de confirmação SWIFT",
      "uploadNumber": "Número de carga",
      "hasErrors": "Tem erros",
      "date-payment-bank": "Data recebida"
    },
    "messages": {
      "paymentRegisteredSucessfully": "Pagamento cadastrado com sucesso em [createDate]",
      "diferentCurrencyCode": "Você não pode reconciliar pagamentos de moedas diferentes",
      "exceedsTolerance": "Excede a tolerância de [tolerence]% permitida",
      "paymentGreaterThen": "Os pagamentos informados pelo contribuinte são superiores ao pagamento informado pela entidade arrecadadora."
    }
  },
  "taxpayer-report": {
    "title": {
      "page": "Consulta contribuinte"
    },
    "label": {
      "name": "Nome",
      "nit": "CPF/CNPJ",
      "county": "País",
      "personType": "Tipo de pessoa",
      "email": "e-mail"
    }
  },
  "taxpayer-request": {
    "label": {
      "personType": "Tipo de pessoa",
      "businessName": "Nome ou nome da empresa",
      "fullName": "Nome completo",
      "id": "Número de identificação",
      "taxNumber": "Número de identificação fiscal",
      "phoneNumber": "Número de telefone",
      "domicile": "Endereço",
      "department": "Departamento / Província / Estado",
      "addContact": "Adicionar contato",
      "operations": "Operações",
      "contacts": "Contatos:",
      "taxVector": "Vetor de impostos",
      "reportVector": "Relatórios",
      "generalData": "Em geral",
      "tax": "Imposto",
      "taxObligation": "Imposto",
      "report": "Relatório",
      "website": "Site web",
      "idTax": "Número de identificação fiscal do país de residência",
      "contactName-tax": "Nome do contato principal",
      "docNumberContact-tax": "Número de identificação de contato",
      "contactTaxIdNumber-tax": "Número de identificação fiscal do contacto no país de residência",
      "phoneNumberContact-tax": "Número de telefone do contato no país de residência",
      "email-tax": "Email de contato",
      "documents": "Documentos",
      "docCompanyRegistrationNumber": "Documento de registro da empresa",
      "docLocalContact": "Documento de identidade do contato no país de residência",
      "acceptance": "Aceitação",
      "taxpayerRequest": "Registro POSS",
      "confirmTerms": "aceita termos e Condições",
      "terms": "Lorem ipsum dor sente-se amet consectetur adipiscing elit per",
      "locale": "Idioma pré-definido",
      "queryOfRequest": "Consulta de Pedido",
      "acquirerId": "Identificação do adquirente",
      "acquirerCountry": "País do adquirente",
      "terminalId": "Identificação do terminal",
      "merchantCategoryCode": "Código da categoria do comerciante",
      "merchantId": "Identificação do comerciante",
      "documentNumberCountryResidence": "Número do documento no país de residência"
    },
    "vector": {
      "label": {
        "tax": "Imposto",
        "expiration": "Dia de expiração",
        "periodicity": "Periodicidade",
        "startOperation": "Início de operação"
      }
    },
    "dialog": {},
    "messages": {
      "contacts": "É necessário pelo menos um contato",
      "operations": "É necessária pelo menos uma operação",
      "selectOperations": "Operações associadas",
      "withoutOperations": "Sem operações",
      "withoutOperationsVector": "Não tem impostos associados",
      "withoutOperationsReport": "Não tem relatórios associados",
      "withoutDocuments": "Não há definição de arquivo"
    },
    "validations": {
      "acceptance": "O campo deve ser selecionado",
      "formComplete": "Preencha todo o formulário"
    }
  },
  "taxpayer-request-val": {
    "title": {
      "page": "Solicitações de contribuintes",
      "approve": "Aprovar Pedido",
      "reject": "Rejeitar pedido",
      "request-additional-info": "Solicite informações adicionais",
      "request": "Solicitação"
    },
    "label": {
      "check-digit": "Dígito de verificação",
      "date-from": "Data de",
      "date-to": "Data Até",
      "request-type": "Tipo de pedido",
      "request": "Solicitação",
      "type": "Tipo",
      "taxpayer": "Contribuinte",
      "state": "Estado",
      "approve": "Passar",
      "reject": "Rejeitar",
      "request-additional-info": "Retornar",
      "comments": "Comentários",
      "reason": "Causa",
      "createdDate": "Data",
      "cancellationDate": "Data de cancelamento"
    },
    "message": {
      "approved": "Aplicação aprovada",
      "rejected": "Pedido rejeitado",
      "request-additional-info": "Solicite informações adicionais",
      "periodictyOutOfDate": "A periodicidade do imposto ou relatórios não está em vigor"
    }
  },
  "taxpayer-taxreturns": {
    "title": {
      "page": "Veja as declarações"
    },
    "label": {
      "nit": "CPF/CNPJ",
      "taxreturnNumber": "Número da Declaração",
      "country": "País",
      "formId": "Forma",
      "taxreturnType": "Tipo de Declaração",
      "taxreturnStatus": "Estado",
      "name": "Nome do contribuinte",
      "period": "Período",
      "periodFrom": "Data de",
      "periodTo": "Data Até",
      "active": "Ativo"
    },
    "header": {
      "actions": "Ações",
      "nit": "CPF/CNPJ",
      "name": "Nome do contribuinte",
      "taxReturnNumber": "Número da Declaração",
      "createDate": "Data",
      "taxreturnType": "Tipo de Declaração",
      "taxreturnStatus": "Estado",
      "form": "Forma",
      "period": "Período",
      "active": "Ativo"
    },
    "validations": {},
    "messages": {},
    "button": {}
  },
  "taxpayer-update-request": {
    "title": {
      "page": "Atualizar registro"
    }
  },
  "taxpayer-unsuscribe-request": {
    "title": {
      "page": "Retirar-se"
    }
  },
  "taxpayer-notification": {
    "title": {
      "sendMessagePage": "Enviar mensagem"
    },
    "label": {
      "nit": "CPF/CNPJ",
      "taxpayerName": "Nome do contribuinte",
      "subject": "Sujeito",
      "message": "Mensagem"
    }
  },
  "form-administration": {
    "title": {
      "page": "Formulário de Administração para Declarações",
      "form": "Forma",
      "versions": "Versões"
    },
    "label": {
      "code": "Código",
      "name": "Nome",
      "shortName": "Nome curto",
      "tax": "Imposto",
      "numberModifications": "Número de emendas",
      "amendmentApprovalRequired": "Emendas requerem aprovação",
      "form": "Forma",
      "versions": "Versões"
    },
    "header": {
      "actions": "Ações",
      "code": "Código",
      "name": "Nome",
      "shortName": "Nome curto",
      "tax": "Imposto"
    },
    "messages": {
      "confirmTitle": "Remover",
      "confirmDeleted": "Você tem certeza que quer apagar isso?"
    }
  },
  "form-cells": {
    "title": {
      "page": "Caixas",
      "serviceParameters": "Parâmetros de serviço",
      "serviceHeaders": "Cabeçalhos de serviço"
    },
    "label": {
      "noFoundCells": "O formulário não tem células definidas",
      "code": "Código da caixa",
      "name": "Caixa de Nome",
      "description": "Descrição",
      "section": "Seção",
      "formula": "Fórmula",
      "order": "Pedido",
      "type": "Tipo",
      "service": "Serviço",
      "mandatory": "Obrigatório",
      "editable": "Editável",
      "visible": "Visível",
      "cellPurpose": "Finalidade da célula",
      "numeric": "Numérico",
      "currency": "Moeda",
      "date": "Data",
      "list": "Preparar",
      "text": "Texto",
      "catalogType": "Tipo de Catálogo",
      "parameterName": "Nome",
      "addParameter": "Adicionar Parâmetro",
      "headerName": "Nome",
      "addHeader": "Adicionar Cabeçalho"
    },
    "messages": {
      "confirmTitle": "Remover",
      "confirmDeleted": "Você tem certeza que quer apagar isso?"
    }
  },
  "form-section": {
    "labels": {
      "description": "Descrição",
      "order": "Pedido",
      "code": "Código",
      "isMultiple": "Seção múltipla",
      "minInstances": "Instâncias mínimas",
      "maxInstances": "Instâncias máximas"
    }
  },
  "form-version": {
    "title": {
      "page": "Versão do formulário",
      "current-account-rules": "Regras da conta corrente"
    },
    "labels": {
      "noFoundVersion": "Não há versão configurada",
      "version": "Versão",
      "formVersion": "Versão do formulário",
      "startDate": "Data de início",
      "endDate": "Data final",
      "formCode": "Código do formulário",
      "formName": "Nome do formulario",
      "since": "Desde a",
      "generalData": "Informações gerais",
      "fields": "Caixas",
      "sections": "Seções",
      "enabled": "Habilitado",
      "preview": "Pré-visualização",
      "current-account-rules": "Regras da conta corrente",
      "account-type-header": "Tipo de conta",
      "transaction-type-header": "Tipo de transação",
      "cell-header": "Caixa",
      "account-type": "Tipo de conta",
      "transaction-type": "Tipo de transação",
      "cell": "Caixa"
    }
  },
  "preview-form": {
    "label": {
      "preview": "Pré-visualizar",
      "year": "Período",
      "taxpayer": "Identificador de contribuinte",
      "nit": "CPF/CNPJ",
      "taxpayerName": "Nome do contribuinte",
      "validTestTaxpayer": "Um contribuinte válido não foi encontrado para o teste",
      "validTestTax": "O contribuinte não possui um imposto relacionado a este formulário",
      "formulaLog": "Log de Fórmulas"
    },
    "messages": {
      "formVersionNotFound": "A versão do formulário não foi encontrada",
      "taxReturnExist": "A declaração já existe para este período"
    },
    "message": {
      "approved": "Aplicação aprovada",
      "rejected": "Pedido rejeitado",
      "request-additional-info": "Solicite informações adicionais",
      "periodictyOutOfDate": "A periodicidade do imposto ou relatórios não está em vigor"
    }
  },
  "taxpayer-taxreturns": {
    "title": {
      "page": "Veja as declarações"
    },
    "label": {
      "nit": "CPF/CNPJ",
      "taxreturnNumber": "Número da Declaração",
      "country": "País",
      "formId": "Forma",
      "taxreturnType": "Tipo de Declaração",
      "taxreturnStatus": "Estado",
      "name": "Nome do contribuinte",
      "period": "Período",
      "periodFrom": "Data de",
      "periodTo": "Data Até",
      "active": "Ativo"
    },
    "header": {
      "actions": "Ações",
      "nit": "CPF/CNPJ",
      "name": "Nome do contribuinte",
      "taxReturnNumber": "Número da Declaração",
      "createDate": "Data",
      "taxreturnType": "Tipo de Declaração",
      "taxreturnStatus": "Estado",
      "form": "Forma",
      "period": "Período",
      "active": "Ativo"
    },
    "validations": {},
    "messages": {},
    "button": {}
  },
  "taxpayer-update-request": {
    "title": {
      "page": "Atualizar registro"
    }
  },
  "taxpayer-unsuscribe-request": {
    "title": {
      "page": "Retirar-se"
    }
  },
  "taxpayer-notification": {
    "title": {
      "sendMessagePage": "Enviar mensagem"
    },
    "label": {
      "nit": "CPF/CNPJ",
      "taxpayerName": "Nome do contribuinte",
      "subject": "Sujeito",
      "message": "Mensagem"
    }
  },
  "form-administration": {
    "title": {
      "page": "Formulário de Administração para Declarações",
      "form": "Forma",
      "versions": "Versões"
    },
    "label": {
      "code": "Código",
      "name": "Nome",
      "shortName": "Nome curto",
      "tax": "Imposto",
      "numberModifications": "Número de emendas",
      "amendmentApprovalRequired": "Emendas requerem aprovação",
      "form": "Forma",
      "versions": "Versões"
    },
    "header": {
      "actions": "Ações",
      "code": "Código",
      "name": "Nome",
      "shortName": "Nome curto",
      "tax": "Imposto"
    },
    "messages": {
      "confirmTitle": "Remover",
      "confirmDeleted": "Você tem certeza que quer apagar isso?"
    }
  },
  "form-cells": {
    "title": {
      "page": "Caixas",
      "serviceParameters": "Parâmetros de serviço",
      "serviceHeaders": "Cabeçalhos de serviço"
    },
    "label": {
      "noFoundCells": "O formulário não tem células definidas",
      "code": "Código da caixa",
      "name": "Caixa de Nome",
      "description": "Descrição",
      "section": "Seção",
      "formula": "Fórmula",
      "order": "Pedido",
      "type": "Tipo",
      "service": "Serviço",
      "mandatory": "Obrigatório",
      "editable": "Editável",
      "visible": "Visível",
      "cellPurpose": "Finalidade da célula",
      "numeric": "Numérico",
      "currency": "Moeda",
      "date": "Data",
      "list": "Preparar",
      "text": "Texto",
      "catalogType": "Tipo de Catálogo",
      "parameterName": "Nome",
      "addParameter": "Adicionar Parâmetro",
      "headerName": "Nome",
      "addHeader": "Adicionar Cabeçalho"
    },
    "messages": {
      "confirmTitle": "Remover",
      "confirmDeleted": "Você tem certeza que quer apagar isso?"
    }
  },
  "form-section": {
    "labels": {
      "description": "Descrição",
      "order": "Pedido",
      "code": "Código",
      "sectionType": "Tipo de seção",
      "isMultiple": "Seção múltipla",
      "minInstances": "Instâncias mínimas",
      "maxInstances": "Instâncias máximas"
    },
    "provisioning": {
      "simple": "Simples",
      "multiple": "Múltipla",
      "jurisdiction": "Jurisdição"
    }
  },
  "form-version": {
    "title": {
      "page": "Versão do formulário",
      "current-account-rules": "Regras da conta corrente"
    },
    "labels": {
      "noFoundVersion": "Não há versão configurada",
      "version": "Versão",
      "formVersion": "Versão do formulário",
      "startDate": "Data de início",
      "endDate": "Data final",
      "formCode": "Código do formulário",
      "formName": "Nome do formulario",
      "since": "Desde a",
      "generalData": "Informações gerais",
      "fields": "Caixas",
      "sections": "Seções",
      "enabled": "Habilitado",
      "preview": "Pré-visualização",
      "current-account-rules": "Regras da conta corrente",
      "account-type-header": "Tipo de conta",
      "transaction-type-header": "Tipo de transação",
      "cell-header": "Caixa",
      "account-type": "Tipo de conta",
      "transaction-type": "Tipo de transação",
      "cell": "Caixa"
    }
  },
  "preview-form": {
    "label": {
      "preview": "Pré-visualizar",
      "year": "Período",
      "taxpayer": "Identificador de contribuinte",
      "nit": "CPF/CNPJ",
      "taxpayerName": "Nome do contribuinte",
      "validTestTaxpayer": "Um contribuinte válido não foi encontrado para o teste",
      "validTestTax": "O contribuinte não possui um imposto relacionado a este formulário",
      "formulaLog": "Log de Fórmulas"
    },
    "messages": {
      "formVersionNotFound": "A versão do formulário não foi encontrada",
      "taxReturnExist": "A declaração já existe para este período"
    }
  },
  "appMenu": {
    "audit-log-application-http": "Registro de HTTP de aplicação",
    "audit-log-security-http": "Registro de HTTP de segurança",
    "catalog": "Catálogos",
    "collection_compliance": "Cobrança e Conformidade",
    "collection_statistics": "Estatísticas de Cobrança",
    "compliance_statistics": "Estatísticas de Conformidade",
    "configuration": "Configurações",
    "configure_penalties": "Configuração de Penalidades",
    "debt_collection_manage": "Ver processos",
    "disable-tfa-to-user": "Desativar Autenticação de Dois Fatores (2FA)",
    "economy-activity": "Operações",
    "environment-application": "Variáveis de aplicação",
    "environment-security": "Variáveis de segurança",
    "home-template": "Modelo de Página Inicial",
    "manage-form": "Formulários",
    "manage-report-operations": "Operações Relatórios Suplementares",
    "manage-report": "Relatórios suplementares",
    "manage-tax-operations": "Operações Impostos",
    "manage-tax": "Impostos",
    "management-report-payment": "Pagamentos",
    "management-report-taxpayer": "Contribuintes",
    "management-report-taxreturn": "Declarações de imposto",
    "management-report": "Relatórios de Gestão",
    "non_compliance": "Controle de Não Conformidade",
    "notifications-application": "Notificações de Aplicação",
    "notifications-security": "Notificações de Segurança",
    "operations": "Operações",
    "query-payments-taxofficer": "Listar Pagamentos",
    "report-details": "Listar Relatórios Suplementares",
    "reports": "Declarações de imposto",
    "security": "Segurança",
    "send-message-taxpayer": "Enviar mensagem",
    "statements-tax-officer": "Declarações de imposto",
    "tax-official-query-amending-credit": "Conta corrente",
    "taxes": "Impostos",
    "taxofficer-check-load-payments": "Verificar informações bancárias",
    "taxofficer-payment-record": "Registro de pagamento",
    "taxofficer-reconciliation-payments": "Conciliação de Pagamentos",
    "taxofficer-taxreturn-payments": "Pagamentos",
    "taxofficer-transaction-adjustment": "Ajuste de saldo",
    "taxofficer-upload-payments": "Carregar informações bancárias",
    "taxpayer-feedback": "Feedback",
    "taxpayer-fields": "Campos do Contribuinte",
    "taxpayer-report": "Lista de Contribuintes",
    "taxpayer-requests": "Solicitações do Contribuinte",
    "taxpayers": "Contribuintes",
    "taxreport-report": "Listar declarações de imposto",
    "taxreturn-evaluation": "Revisão de Alterações",
    "terms-template": "Modelo de Termos e Condições",
    "two-factor-authentication": "Autenticação de dois fatores",
    "user-taxpayers": "Contribuintes",
    "users": "Usuários"
  }
}
